import "datatables.net"
import "datatables.net-bs4"
// import "datatables.net-responsive"
// import "datatables.net-responsive-bs4"
import "datatables.net-buttons"
import "datatables.net-buttons-bs4"
import "datatables.net-buttons/js/buttons.html5"
import "datatables.net-buttons/js/buttons.colVis"
// import "datatables.net-keytable"
// import "datatables.net-select"

export function attachDataTables(context) {
    const $context = $(context);
    $context.find('.dataTable').each(function() {
        /**
         * .dtc prefix stands for 'DataTable Custom'
         *
         * table class list:
         * .dtc-column-visibility - enables column visibility functionality
         * .dtc-excel - enables download as excel or csv
         *
         * column class list:
         * .dtc-column-visibility - marks column as available for toggle visibility
         * .dtc-hidden - sets column as hidden by default
         * .dtc-excel - marks column to download (if is visible)
         * .dtc.column-title - sets element as title source for downloaded file (eg. select2 adds all options to header of downloaded column)
         * .dtc-order-asc - sets asc column order
         * .dtc-order-desc - sets desc column order
         */
        const buttons = [];
        if ($(this).hasClass('dtc-column-visibility')) {
            buttons.push([
                {
                    extend: 'colvis',
                    text: 'Column visibility',
                    columns: '.dtc-column-visibility',
                    collectionLayout: 'two-column',
                    className: 'btn-primary',
                },
            ])
        }
        if ($(this).hasClass('dtc-select-all')) {
            buttons.push([{
                text: 'Select all',
                className: 'btn btn-primary',
                action: function ( e, dt, node, config ) {
                    dt.$('.dtc-select-all-checkbox').each(function(index, el){
                        $(el).prop('checked', true);
                    });
                }
            }]);
        }
        if ($(this).hasClass('dtc-excel')) {
            buttons.push([
                {
                    extend: 'collection',
                    text: 'Download',
                    className: 'btn-primary',
                    buttons: [
                        {
                            extend: 'excel',
                            exportOptions: {
                                columns: (idx, data, node) => $(node).is('.dtc-excel:visible'),
                                format: {
                                    header: function (data, idx, node) {
                                        const customTitle = $(node).find('.dtc-column-title').text();
                                        if (!!customTitle) {
                                            return customTitle;
                                        }
                                        return $(node).text();
                                    }
                                }
                            },
                            autoFilter: true
                        },
                        {
                            extend: 'csv',
                            exportOptions: {
                                columns: (idx, data, node) => $(node).is('.dtc-excel:visible'),
                                format: {
                                    header: function (data, idx, node) {
                                        const customTitle = $(node).find('.dtc-column-title').text();
                                        if (!!customTitle) {
                                            return customTitle;
                                        }
                                        return $(node).text();
                                    }
                                }
                            }
                        },
                    ],
                }
            ]);
        }


        const table = $(this).DataTable({
            initComplete: function () {
                this.api().columns().every(function () {
                    var that = this;
                    $('input, select', this.header()).on('click keyup change clear', function (e) {
                        e.stopPropagation();
                        if (that.search() !== this.value) {
                            that.search(this.value).draw();
                        }
                    });
                });
            },
            language: {
                paginate: {
                    previous: '<i class="bx bx-chevron-left font-size-16 align-middle mr-2"></i>',
                    next: '<i class="bx bx-chevron-right font-size-16 align-middle mr-2"></i>',
                    first: '<i class="bx bx-first-page font-size-16 align-middle mr-2"></i>',
                    last: '<i class="bx bx-last-page font-size-16 align-middle mr-2"></i>'
                },
                info: "Displaying _START_ - _END_ of _TOTAL_ results",
                infoEmpty: "No entries to show"
            },
            columnDefs: [
                {
                    targets: 'no-sort',
                    orderable: false,
                }
            ],
            dom: (buttons.length ? 'B' : '') + '<"table-responsive"t>' + 'r<"row table-bottom"<"col-sm-12 col-md-2"l><"col-sm-12 col-md-7"p><"col-sm-12 col-md-3"i>>',
            pagingType: "full_numbers",
            fixedColumns: true,
            autoWidth: false,
            buttons: {
                buttons,
                dom: {
                    button: {
                        className: 'btn'
                    }
                }
            },
            processing: true,
        });

        const orderColumnIndex = table.column('th[class^="dtc-order-"],th[class*=" dtc-order-"]').index();
        const orderDirection = typeof table.column('th[class^="dtc-order-asc"],th[class*=" dtc-order-asc"]').index() === 'undefined'
            ? 'desc'
            : 'asc';
        if (undefined !== orderColumnIndex) {
            table.order([orderColumnIndex, orderDirection]).draw();
        }

        table.columns('.dtc-hidden').visible(false);

        $context.on('click', 'td.withDetails', function () {
            const $tr = $(this).closest('tr');
            const row = table.row( $tr );

            if (row.child.isShown()) {
                row.child.hide();
                $tr.find('.withDetailsIcon em')
                    .removeClass('bx-minus-circle')
                    .addClass('bx-plus-circle')

                return;
            }

            row.child( $tr.find('.withDetails .details').html() ).show();
            $tr.find('.withDetailsIcon em')
                .removeClass('bx-plus-circle')
                .addClass('bx-minus-circle')
        });
    });
    $context.find('.dataTableWithoutPagination').DataTable({
        initComplete: function () {
            this.api().columns().every(function () {
                var that = this;
                $('input, select', this.header()).on('click keyup change clear', function (e) {
                    e.stopPropagation();
                    if (that.search() !== this.value) {
                        that.search(this.value).draw();
                    }
                });
            });
        },
        language: {
            info: "Displaying _START_ - _END_ of _TOTAL_ results",
            infoEmpty: "No entries to show"
        },
        columnDefs: [
            {
                targets: 'no-sort',
                orderable: false,
            }
        ],
        dom: 'rt<"row table-bottom"<"col-sm-12 col-md-2"l><"col-sm-12 col-md-7"p><"col-sm-12 col-md-3"i>>',
        paging: false,
        fixedColumns: true,
        autoWidth: false,
    });
    $context.find('.data-table-column-search').on('click', function (e) {
        e.stopPropagation();
    });
    $context.find('.pagination').addClass('pagination-rounded');
}
